export default __webpack_public_path__ + "static/media/agve.7b5224a1.png";